__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/230e238/_next/";